import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import 'react-toastify/dist/ReactToastify.css';
import "core-js";
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import { icons } from "./assets/icons";
import { Provider } from "react-redux";
import store from "./store";
import { useHistory } from "react-router";
import { ToastContainer } from "react-toastify";

const configureToken = async () => {
  const user = localStorage.getItem("user");
  if (user) {
    const { accessToken } = JSON.parse(localStorage.getItem("user"));
    axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  }
};

// Token refresh
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    let originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      try {
        // We are unauthorized, try to obtain a new token
        originalRequest._retry = true;
        const { refreshToken } = JSON.parse(localStorage.getItem("user"));
        const {
          data: { accessToken },
        } = await axios.post(`${process.env.REACT_APP_API_URL}/token`, {
          refreshToken,
        });
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${accessToken}`;
        const user = JSON.parse(localStorage.getItem("user"));
        user.accessToken = accessToken;
        localStorage.setItem("user", JSON.stringify(user));
        return axios(originalRequest);
      } catch (err) {
        localStorage.removeItem("user");
        window.location.href = "/#/login";
      }
    }
  }
);

configureToken();

React.icons = icons;

ReactDOM.render(
  <Provider store={store}>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
